import type { OutboxItem } from "./outboxScheduler";

export function computeEvictedCaseIds(
  knownCaseIds: string[],
  inScopeCaseIds: string[]
): string[] {
  const scope = new Set(inScopeCaseIds);
  return knownCaseIds.filter((id) => !scope.has(id));
}

export function quarantineOutboxForEvictedCases(
  items: OutboxItem[],
  evictedCaseIds: string[],
  notice: string
): OutboxItem[] {
  const evicted = new Set(evictedCaseIds);
  return items.map((item) => {
    if (!item.caseId || !evicted.has(item.caseId)) return item;
    if (item.status === "synced") return item;
    return {
      ...item,
      status: "quarantine",
      error: notice,
      updatedAt: new Date().toISOString(),
    };
  });
}

export function dropCasesFromBundle<T extends { id: string }>(
  rows: T[],
  evictedCaseIds: string[]
): T[] {
  const evicted = new Set(evictedCaseIds);
  return rows.filter((row) => !evicted.has(row.id));
}
